import { createContext, useContext } from 'react';

import { priorityFilterStrategy } from '../strategies/priority-filter-strategy';
import type { CommandRankingStrategy } from '../types/command-strategy';

/**
 * Carries the active {@link CommandRankingStrategy} from the palette
 * provider down to the results components. Default is
 * `priorityFilterStrategy` (predictable, muscle-memory-preserving);
 * consumers opt in to `relevanceStrategy` (or roll their own) via the
 * provider's `rankingStrategy` prop.
 *
 * Held in its own context rather than co-located with the registry
 * context because the strategy has a different lifecycle: it's set
 * once at provider creation (or per-app), where the registry mutates
 * on every register/unregister. Coupling them would force every
 * registry consumer to re-render on the (extremely rare) strategy
 * switch.
 */
export const CommandPaletteStrategyContext = createContext<CommandRankingStrategy>(priorityFilterStrategy);

/**
 * Read the active ranking strategy. Convention wrapper to match
 * how the rest of the palette accesses its contexts (every other
 * context has a `useFoo` hook; this one was the odd one out).
 */
export function useCommandStrategy(): CommandRankingStrategy {
  return useContext(CommandPaletteStrategyContext);
}
